<template>
  <header id="header" class="header">

    <div class="container">

      <div class="header-content">

        <nav class="logo-wrapper">

          <RouterLink to="/" class="logo-container">

            <div class="logo-img-wrapper">

              <img
                :src="logo"
                alt="Black Paladins"
                class="logo-img"
              />

            </div>

            <div class="logo-text">
              BLACK PALADINS
            </div>

          </RouterLink>

        </nav>

        <nav class="nav-desktop" :class="{ open: isOpen }">

          <RouterLink
            to="/"
            class="menu-link"
            @click="closeMenu"
          >
            {{ headerLocale.home }}
          </RouterLink>

          <RouterLink
            to="/#about"
            class="menu-link"
            @click="closeMenu"
          >
            {{ headerLocale.about }}
          </RouterLink>

          <RouterLink
            to="/#projects"
            class="menu-link"
            @click="closeMenu"
          >
            {{ headerLocale.projects }}
          </RouterLink>

          <RouterLink
            to="/#team"
            class="menu-link"
            @click="closeMenu"
          >
            {{ headerLocale.team }}
          </RouterLink>

          <!--
          <RouterLink
            to="/#contact"
            class="menu-link"
            @click="closeMenu"
          >
            {{ headerLocale.contact }}
          </RouterLink>
          -->
        </nav>

        <RouterLink to="/#contact" class="cta-btn">

          <span>
            {{ headerLocale.contratar }}
          </span>

          <img
            :src="setaLado"
            class="cta-icon"
          />

        </RouterLink>

        <button
          class="mobile-btn"
          aria-label="Abrir menu"
          @click="toggleMenu"
        >

          <span :class="{ active: isOpen }"></span>

          <span :class="{ active: isOpen }"></span>

          <span :class="{ active: isOpen }"></span>

        </button>

      </div>

    </div>

    <div
      v-if="isOpen"
      class="menu-overlay"
      @click="closeMenu"
    ></div>

    <div
      v-if="isOpen"
      class="mobile-menu"
    >

      <RouterLink
        to="/"
        class="menu-link"
        @click="closeMenu"
      >
        {{ headerLocale.home }}
      </RouterLink>

      <RouterLink
        to="/#about"
        class="menu-link"
        @click="closeMenu"
      >
        {{ headerLocale.about}}
      </RouterLink>

      <RouterLink
        to="/#projects"
        class="menu-link"
        @click="closeMenu"
      >
        {{ headerLocale.projects }}
      </RouterLink>

      <RouterLink
        to="/#team"
        class="menu-link"
        @click="closeMenu"
      >
        {{ headerLocale.team}}
      </RouterLink>

      <!--
      <RouterLink
        to="/#contact"
        class="menu-link"
        @click="closeMenu"
      >
        {{ headerLocale.contact }}
      </RouterLink>
      -->
      <RouterLink
        to="/#contact"
        class="menu-link"
        @click="closeMenu"
      >
        {{ headerLocale.contratar}}
      </RouterLink>

    </div>

  </header>
</template>

<script setup>
import { ref } from "vue"
import { RouterLink } from "vue-router"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { header } from "@/data/header"

import logo from "@/assets/logo/logo.png"
import setaLado from "@/assets/icons/setaProLado.png"

const { locale } = useI18n()

const headerLocale = computed(() => {

  if (locale.value === "pt") {
    return header.pt
  }

  return header.en

})

const isOpen = ref(false)

const toggleMenu = () => {
  isOpen.value = !isOpen.value
}

const closeMenu = () => {
  isOpen.value = false
}


</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 50;
  background: var(--bg-header);
  border-bottom: 1px solid var(--card-base);
  text-transform: uppercase;
}

.container {
  max-width: 1300px;
  margin: auto;
}

.header-content {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.logo-img-wrapper {
  position: relative;
}

.logo-img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.logo-text {
  font-weight: bold;
  font-size: 24px;
  letter-spacing: 1.5px;
}

.nav-desktop {
  display: flex;
  gap: 32px;
}

.nav-desktop a {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
  text-decoration: none;
  color: var(--cor-texto-principal);
  opacity: 0.8;
  transition: 0.3s;
}

.nav-desktop a:hover {
  color: var(--card-destaque);
  font-weight: 700;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 12px;
  text-decoration: none;
  background: linear-gradient(135deg, #431491, #7A33B6);
  transition: 0.3s;
  font-size: 14px;
  font-weight: 600;
  color: var(--cor-texto-principal);
}

.cta-btn:hover {
  box-shadow: 0 0 25px rgba(122, 51, 182, 0.4);
}

.cta-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.mobile-btn {
  display: none;
  width: 22px;
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
  z-index: 100;
}

.mobile-btn span {
  display: block;
  width: 100%;
  height: 2px;
  margin: 5px 0;
  background: var(--cor-texto-principal);
  border-radius: 2px;
  transition: 0.3s;
}

.mobile-btn span.active:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.mobile-btn span.active:nth-child(2) {
  opacity: 0;
}

.mobile-btn span.active:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

.menu-overlay {
  position: fixed;
  inset: 0;
  height: 100vh;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(3px);
  z-index: 60;
}

.mobile-menu {
  position: fixed;
  top: 70px;
  right: 0;
  z-index: 90;
  height: calc(100vh - 70px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: var(--bg-header);
  border-left: 1px solid var(--card-base);
  transform: translateX(0);
  transition: 0.3s;
}

.mobile-menu a {
  text-decoration: none;
  color: var(--cor-texto-suave);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
}

.mobile-menu a:hover {
  color: var(--cor-texto-principal);
}

@media (max-width: 1280px) {

  .container {
    max-width: 1200px;
    padding: 0 20px;
  }

}

@media (max-width: 800px) {

  .header-content {
    height: 70px;
  }

  .container {
    max-width: 700px;
    padding: 0 20px;
  }

  .logo-img {
    width: 40px;
    height: 40px;
  }

  .logo-text {
    display: none;
  }

  .nav-desktop {
    display: none;
  }

  .cta-btn {
    display: none;
  }

  .mobile-btn {
    display: block;
  }

}
</style>